export const createDto = (id, page, entity) => ({
  id,
  page,
  filterType: 0,
  order: entity.order,
  title: entity.title,
  columns: entity.columns.map(x => ({ json: JSON.stringify(x) }))
})